import { ImageProps } from "@commonlibs";
import clsx from "clsx";
import { BannerRoot, SizeBanner } from "./Banner.styles";

export interface BannerProps extends ImageProps {
    size?: SizeBanner;
}

function Banner({ className, ...rest }: BannerProps) {
    return <BannerRoot className={clsx("banner", className)} {...rest} />;
}

export default Banner;
